import React from 'react';

function FooterComponent() {
  return <p className='mt-4 mb-1 text-muted'>&copy;2024 Rota Pad v3.1</p>;
}

export default FooterComponent;
